import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  color: #ffffff;
  background-color: #bb0a00;
  margin: 20px;
  padding: 10px;
  max-width: 849px;
  border-radius: 5px;
`;

function Alert(props) {
  return <Container {...props}>{props.children}</Container>;
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Alert/index.jsx